<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data(){
    return{}
  },
  created(){
    document.title = '微商联智能crm';
    console.log('app')
  }
};
</script>

<style>
</style>
